import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { useAppDispatch } from "../../../app/store";
import { fetchDisbursements } from "../Logic/disbursementsThunk";
import { DisbursementsTable } from "./DisbursementsTable";

const DisbursementsContainer: React.FC = () => {
    const { id: caseId } = useParams<{ id: string }>();
    const dispatch = useAppDispatch();

    useEffect(() => {
      if (!caseId) return;

      dispatch(fetchDisbursements(caseId));
    }, [caseId, dispatch]);

    if (!caseId) return null;

    return (
      <div className="mt-4 px-4 pb-4 min-w-0">
        <DisbursementsTable />
      </div>
    );
};

export default DisbursementsContainer;